import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from '~/utils';

export const withDefaultHash = (defaultHash) => (Component) =>
  class ComponentWithDefaultHash extends PureComponent {
    static propTypes = {
      history: PropTypes.shape({
        replaceWithToken: PropTypes.func.isRequired,
      }).isRequired,
      location: PropTypes.shape({
        search: PropTypes.string.isRequired,
        hash: PropTypes.string.isRequired,
        pathname: PropTypes.string.isRequired,
      }).isRequired,
    };

    constructor(props) {
      super(props);
      const {
        location: { hash, search, pathname },
        history,
      } = this.props;
      if (isEmpty(hash) && isEmpty(search)) {
        history.replaceWithToken({
          pathname,
          hash: defaultHash,
        });
      }
    }

    render() {
      return <Component {...this.props} />;
    }
  };
